import { Component, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

interface NavItem {
  id: string;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-profile-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './profile-layout.html'
})
export class ProfileLayout {
  private router = inject(Router);

  activeTab = signal('account');

  navItems = signal<NavItem[]>([
    {
      id: 'account',
      label: 'Account',
      icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z'
    }
  ]);

  constructor() {
    this.updateActiveTab();
  }

  private updateActiveTab() {
    const url = this.router.url;
    if (url.includes('/profile/settings')) {
      this.activeTab.set('settings');
    } else {
      this.activeTab.set('account');
    }
  }

  onTabChange(tabId: string) {
    this.activeTab.set(tabId);
    this.router.navigate(['/profile', tabId]);
  }
}
